import React from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import store from "store/index";
import Loader from "./layouts/Loader/Loader";
import { ToastContainer } from "react-toastify";
import { IdleTimerProviderComponent } from "../src/idleTimer/IdleTimerContext";
import AppRoutes from "routes/AppRoutes";
import "react-toastify/dist/ReactToastify.css";
import "./index.scss";

const Root = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <IdleTimerProviderComponent>
          <React.Suspense fallback={<Loader />}>
            <AppRoutes />
          </React.Suspense>
          <ToastContainer />
        </IdleTimerProviderComponent>
      </BrowserRouter>
    </Provider>
  );
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);
